import { AccountPlanType } from 'enums';

export interface AccountPlansConfig {
  title: string;
  subtitle: string;
  body: string;
  caption: string;
  planId: string;
  type: AccountPlanType;
  monthlyLimits: {
    newUsers: number;
    bulkMessages: number;
  };
}

export const accountPlansConfig: { [key in Exclude<AccountPlanType, 'Unlimited'>]?: AccountPlansConfig } = {
  [AccountPlanType.Pro]: {
    title: 'Teleform Pro',
    subtitle: 'Unlock Professional Features with Teleform Pro',
    body:
        'Step up your game with our Pro Plan. Gain access to advanced ' +
        'features like External integration Node, Human Handoff, enhanced ' +
        'support, and increased limits to boost your productivity and efficiency.',
    caption: '$9.99/Month',
    planId: process.env.REACT_APP_PAYPAL_PRO_PLAN_ID!,
    type: AccountPlanType.Pro,
    monthlyLimits: {
      newUsers: 500,
      bulkMessages: 3000
    }
  },
  [AccountPlanType.Premium]: {
    title: 'Teleform Premium Team',
    subtitle: 'Empower Your Team with Teleform Premium Team',
    body:
        'Bring your team together with the Premium Team Plan. This plan ' +
        'includes everything in Pro, plus powerful collaboration tools like ' +
        'Ticketing System, shared resources, and administrative controls to ' +
        'manage team roles and permissions.',
    caption: '$15.99/Month',
    planId: process.env.REACT_APP_PAYPAL_PREMIUM_PLAN_ID!,
    type: AccountPlanType.Premium,
    monthlyLimits: {
      newUsers: 5000,
      bulkMessages: 200000
    }
  },
  [AccountPlanType.BroadcastLite]: {
    title: 'Teleform Broadcast Lite',
    subtitle: 'Lean Messaging Power with Broadcast Lite',
    body:
        'Start strong with the Broadcast Lite Plan. Perfect for early-stage growth with full access to core Teleform features.',
    caption: '$69.99/Month',
    planId: process.env.REACT_APP_PAYPAL_BROADCAST_LITE_PLAN_ID!,
    type: AccountPlanType.BroadcastLite,
    monthlyLimits: {
      newUsers: 30000,
      bulkMessages: 5000000
    }
  },
  [AccountPlanType.BroadcastStart]: {
    title: 'Teleform Broadcast Start',
    subtitle: 'Scale Confidently with Broadcast Start',
    body:
        'A great choice for projects gaining steady momentum with enhanced messaging capabilities.',
    caption: '$99.99/Month',
    planId: process.env.REACT_APP_PAYPAL_BROADCAST_START_PLAN_ID!,
    type: AccountPlanType.BroadcastStart,
    monthlyLimits: {
      newUsers: 50000,
      bulkMessages: 25000000
    }
  },
  [AccountPlanType.BroadcastRise]: {
    title: 'Teleform Broadcast Rise',
    subtitle: 'Fuel Growth with Broadcast Rise',
    body:
        'Built for fast-growing bots and consistent engagement with advanced messaging features.',
    caption: '$129.99/Month',
    planId: process.env.REACT_APP_PAYPAL_BROADCAST_RISE_PLAN_ID!,
    type: AccountPlanType.BroadcastRise,
    monthlyLimits: {
      newUsers: 70000,
      bulkMessages: 45000000
    }
  },
  [AccountPlanType.BroadcastPrime]: {
    title: 'Teleform Broadcast Prime',
    subtitle: 'High-Scale Messaging with Broadcast Prime',
    body:
        'Our most powerful plan with infrastructure priority and early access to new features.',
    caption: '$149.99/Month',
    planId: process.env.REACT_APP_PAYPAL_BROADCAST_PRIME_PLAN_ID!,
    type: AccountPlanType.BroadcastPrime,
    monthlyLimits: {
      newUsers: 100000,
      bulkMessages: 60000000
    }
  },
};
